export default "__VITE_ASSET__CHbBtbb$__"